module.exports = __webpack_public_path__ + "img/icon_yezza_square.373a5d4c.png";